<div class="d-flex align-items-stretch">
  <nav id="sidebar">
    <!-- Sidebar Header-->
    <div class="sidebar-header d-flex align-items-center">
      <div class="avatar"><img src="assets/images/blue-profile.png" alt="..." class="img-fluid rounded-circle" /></div>
      <div class="title">
        <h1 class="h5 ellipsis">{{ userData.user_name }}</h1>
        <p class="ellipsis">{{ userData.email }}</p>
      </div>
    </div>
    <!-- Sidebar Navidation Menus--><span class="heading">Main</span>
    <ul class="list-unstyled">
      <ng-container>
        <li>
          <a routerLink="/home" routerLinkActive="active"> <i class="icon-home"></i>Home </a>
        </li>
        <li>
          <a routerLink="/profile" routerLinkActive="active"> <i class="icon-user"></i>My Account </a>
        </li>
        <!-- <li><a routerLink="/about" routerLinkActive="active"> <i class="icon-home"></i>About </a></li> -->
        <li *ngIf="userData.plan">
          <a routerLink="/transactions" routerLinkActive="active"> <i class="icon-list"></i>Transactions </a>
        </li>
      </ng-container>
    </ul>
  </nav>
</div>
